import React, { useState, useEffect } from 'react';
import { AdminLayout } from '../../components/admin/AdminLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { BookOpen, MessageSquare, Users, Award } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const AdminDashboard = () => {
  const [stats, setStats] = useState({
    classes: 0,
    messages: 0,
    testimonials: 0,
    partners: 0
  });

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const [classes, messages, testimonials, partners] = await Promise.all([
        axios.get(`${API}/classes`),
        axios.get(`${API}/contact/messages`),
        axios.get(`${API}/testimonials`),
        axios.get(`${API}/partners`)
      ]);
      setStats({
        classes: classes.data.length,
        messages: messages.data.length,
        testimonials: testimonials.data.length,
        partners: partners.data.length
      });
    } catch (error) {
      console.error('Error fetching stats:', error);
    }
  };

  return (
    <AdminLayout title="Dashboard">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <Card>
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium text-gray-600">Total Classes</CardTitle>
            <BookOpen className="text-red-600" size={20} />
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-bold">{stats.classes}</div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium text-gray-600">Contact Messages</CardTitle>
            <MessageSquare className="text-blue-600" size={20} />
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-bold">{stats.messages}</div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium text-gray-600">Testimonials</CardTitle>
            <Users className="text-green-600" size={20} />
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-bold">{stats.testimonials}</div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium text-gray-600">Partners</CardTitle>
            <Award className="text-purple-600" size={20} />
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-bold">{stats.partners}</div>
          </CardContent>
        </Card>
      </div>

      <div className="mt-8">
        <Card>
          <CardHeader>
            <CardTitle>Quick Actions</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <a href="/admin/classes" className="p-4 border-2 rounded-lg hover:border-red-600 transition-colors">
                <BookOpen className="text-red-600 mb-2" size={24} />
                <h3 className="font-semibold">Manage Classes</h3>
                <p className="text-sm text-gray-600">Edit prices and availability</p>
              </a>
              <a href="/admin/messages" className="p-4 border-2 rounded-lg hover:border-blue-600 transition-colors">
                <MessageSquare className="text-blue-600 mb-2" size={24} />
                <h3 className="font-semibold">View Messages</h3>
                <p className="text-sm text-gray-600">Check contact form submissions</p>
              </a>
              <a href="/admin/faqs" className="p-4 border-2 rounded-lg hover:border-green-600 transition-colors">
                <Users className="text-green-600 mb-2" size={24} />
                <h3 className="font-semibold">Manage FAQs</h3>
                <p className="text-sm text-gray-600">Add or edit FAQ content</p>
              </a>
            </div>
          </CardContent>
        </Card>
      </div>
    </AdminLayout>
  );
};
